export const environment = {
  production: true,
  chatbot: {
    baseUrl: 'https://sensesphere.ai',
    icd10BotUuid: '6a4fb706-d166-461c-9534-b6ba38041dfe',
    icd9BotUuid: '0cf0ecb8-31cf-4bb6-a84b-11e14f8e4e65',
    icfBotUuid: '7cf34ce6-2d5d-42ee-8fa3-d3226d987cf4',
    enabled: true
  }
};
